'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _calculateElementSize = require('./calculateElementSize');

var _calculateElementSize2 = _interopRequireDefault(_calculateElementSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
    var ElementResizeHandleTouch = function (_React$Component) {
        _inherits(ElementResizeHandleTouch, _React$Component);

        function ElementResizeHandleTouch() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, ElementResizeHandleTouch);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ElementResizeHandleTouch.__proto__ || Object.getPrototypeOf(ElementResizeHandleTouch)).call.apply(_ref, [this].concat(args))), _this), _this.onTouchMove = function (event) {
                var _this$props = _this.props,
                    setTempElementSize = _this$props.setTempElementSize,
                    element = _this$props.element,
                    minWidth = _this$props.minWidth;

                var elementSize = element.getIn(['content', 'width']);

                event.preventDefault();
                event.stopPropagation();

                if (event.touches.length < 2) return;

                var gestureSize = _this.getGestureSize(event);
                var sizeChange = gestureSize - _this.gestureSizeStart;

                _this.elementSize = (0, _calculateElementSize2.default)(elementSize, sizeChange, minWidth);

                setTempElementSize(_this.elementSize);
            }, _this.onTouchEnd = function (event) {
                var setElementSize = _this.props.setElementSize;


                event.preventDefault();
                event.stopPropagation();

                document.removeEventListener('touchmove', _this.onTouchMove);
                document.removeEventListener('touchend', _this.onTouchEnd);

                setElementSize(_this.elementSize);
            }, _this.onTouchStart = function (event) {
                var setTempElementSize = _this.props.setTempElementSize;

                if (!setTempElementSize) return;

                event.preventDefault();

                document.addEventListener('touchmove', _this.startTouchDragging);
                document.addEventListener('touchend', _this.cancelTouchDragging);
            }, _this.getGestureSize = function (event) {
                var gridSize = _this.props.gridSize;


                var touchA = event.touches.item(0);
                var touchB = event.touches.item(1);

                var dx = touchB.clientX - touchA.clientX;
                var dy = touchB.clientY - touchA.clientY;

                return Math.sqrt(dx * dx + dy * dy) / gridSize;
            }, _this.startTouchDragging = function (event) {
                if (event.touches.length < 2) return _this.cancelTouchDragging();

                document.removeEventListener('touchmove', _this.startTouchDragging);
                document.removeEventListener('touchend', _this.cancelTouchDragging);

                _this.gestureSizeStart = _this.getGestureSize(event);

                document.addEventListener('touchmove', _this.onTouchMove);
                document.addEventListener('touchend', _this.onTouchEnd);
            }, _this.cancelTouchDragging = function (event) {
                document.removeEventListener('touchmove', _this.startTouchDragging);
                document.removeEventListener('touchend', _this.cancelTouchDragging);
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(ElementResizeHandleTouch, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Component, _extends({}, this.props, { onTouchStart: this.onTouchStart }));
            }
        }]);

        return ElementResizeHandleTouch;
    }(_react2.default.Component);

    ElementResizeHandleTouch.propTypes = {
        children: _propTypes2.default.node,
        element: _propTypes2.default.object,
        gridSize: _propTypes2.default.number,
        inList: _propTypes2.default.string,
        showHandle: _propTypes2.default.bool,
        setElementSize: _propTypes2.default.func,
        setTempElementSize: _propTypes2.default.func,
        minWidth: _propTypes2.default.number
    };

    return ElementResizeHandleTouch;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/resizing/elementResizeHandleTouchDecorator.js
// module id = 2008
// module chunks = 0